var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',[_c('el-col',[_c('el-menu',{staticClass:"el-menu-vertical-demo full-height",attrs:{"router":_vm.routerMode,"background-color":"#304156","text-color":"#bfcbd9","default-active":_vm.activeIndex,"collapse-transition":true,"unique-opened":true}},[_vm._t("trademark"),_vm._t("router")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }